import ExperienceList from "../../components/Experiences/ExperienceList";


export default function ExperienceListPage() {
  return <ExperienceList />;
}
